const formatarReais = valor => parseFloat(valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })

const formatarReaisInteiros = valor => parseFloat(valor || 0)
  .toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 0, maximumFractionDigits: 0 })

const participacao = (valor, total) => (valor && total ? Math.round(10000 * Math.abs(valor / total)) / 100 : 0)

const opcoesComuns = categorias => ({
  chart: { toolbar: { show: false } },
  plotOptions: { bar: { horizontal: false, columnWidth: "45%", endingShape: "rounded" } },
  dataLabels: { enabled: false },
  stroke: { show: true, width: 2, colors: ["transparent"] },
  grid: { borderColor: "#f1f1f1" },
  fill: { opacity: 1 },
  xaxis: { categories: categorias }
})

/**
 * Ticket e faturamento têm ordens de grandeza diferentes (centenas × milhares). Cada um
 * fica no seu eixo, em reais: os dois tickets dividem o eixo da esquerda, com a mesma
 * escala, e o faturamento usa o da direita. Antes o faturamento era dividido por mil para
 * caber no eixo dos tickets, e a coluna dele parecia a menor do canal.
 */
const graficoEmValor = ({ valores, t, categorias }) => {
  const nomes = {
    ticketPessoa: t("dashboard.lista.valorCanal.ticketmedio"),
    ticketAtendimento: t("dashboard.lista.valorCanal.ticketmedioatendimento"),
    faturamento: t("dashboard.lista.valorCanal.faturamento")
  }

  const ticketsPessoa = valores.map(v => v.Ticket_Medio_Pessoa || 0)
  const ticketsAtendimento = valores.map(v => v.Ticket_Medio || 0)
  const faturamentos = valores.map(v => v.Valor_Total || 0)

  // Os dois eixos de ticket precisam do mesmo máximo para as colunas serem comparáveis.
  const maiorTicket = Math.max(0, ...ticketsPessoa, ...ticketsAtendimento)
  const escalaTickets = { min: 0, max: maiorTicket > 0 ? Math.ceil(maiorTicket * 1.1) : 1, forceNiceScale: true }

  const formatarMilhares = valor => (Math.abs(valor) >= 1000
    ? t("dashboard.lista.valorCanal.milhares", {
      valor: (valor / 1000).toLocaleString("pt-BR", { maximumFractionDigits: 1 })
    })
    : formatarReaisInteiros(valor))

  return {
    series: [
      { name: nomes.ticketPessoa, data: ticketsPessoa },
      { name: nomes.ticketAtendimento, data: ticketsAtendimento },
      { name: nomes.faturamento, data: faturamentos }
    ],
    options: {
      ...opcoesComuns(categorias),
      colors: ["#34c38f", "#556ee6", "#f8b425"],
      yaxis: [
        {
          seriesName: nomes.ticketPessoa,
          ...escalaTickets,
          title: { text: t("dashboard.lista.valorCanal.eixo.ticket") },
          labels: { formatter: formatarReaisInteiros }
        },
        { seriesName: nomes.ticketPessoa, ...escalaTickets, show: false },
        {
          seriesName: nomes.faturamento,
          opposite: true,
          min: 0,
          forceNiceScale: true,
          title: { text: t("dashboard.lista.valorCanal.eixo.faturamento") },
          labels: { formatter: formatarMilhares }
        }
      ],
      tooltip: { y: { formatter: valor => formatarReais(valor) } }
    }
  }
}

/**
 * Em percentual só a participação no faturamento tem significado: somar tickets médios
 * dos canais para calcular "participação" de ticket não representa nada.
 */
const graficoEmPercentual = ({ valores, t, categorias }) => {
  const totalFaturamento = valores.reduce((total, v) => total + (v.Valor_Total || 0), 0)

  return {
    series: [{
      name: t("dashboard.lista.valorCanal.participacaofaturamento"),
      data: valores.map(v => participacao(v.Valor_Total || 0, totalFaturamento))
    }],
    options: {
      ...opcoesComuns(categorias),
      colors: ["#f8b425"],
      yaxis: {
        min: 0,
        max: 100,
        title: { text: t("dashboard.lista.valorCanal.percentual.label") },
        labels: { formatter: valor => `${valor}%` }
      },
      tooltip: { y: { formatter: valor => `${String(valor).replace(".", ",")}%` } }
    }
  }
}

export const montarGraficoVendasCanal = ({ valores, tipo, t, nomeCanal }) => {
  const lista = valores || []
  const categorias = lista.map(v => nomeCanal(v.Canal))
  return tipo === "percentual"
    ? graficoEmPercentual({ valores: lista, t, categorias })
    : graficoEmValor({ valores: lista, t, categorias })
}
